import {
  Avatar,
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext} from "react";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { alpha, useTheme } from "@mui/material/styles";
import {
  PRIMARY_COLOR_MediumRoyalBlue,
} from "../../../constants/Colors";
import { TeamContext } from "../../../contexts/TeamsContext";
import TeamModal from "./TeamModal";
import { makeStyles } from "@mui/styles";
import { getAPIEndpointUrl } from "../../../utils/ServerRequestModifier";
import ConfirmationDialog from "../../../general_components/ConformationDialog";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}));

export default function TeamCard({ item, setOpenDetail, setDetailItem }) {

  const classes = useStyles();
  const theme = useTheme();
  const [show, setShow] = React.useState(-1);
  const [open, setOpen] = React.useState(false);
  const { handleDeleteTeam, handleEditTeam, load, openDel, setOpenDel,
    setClickedTeamId, handleAddData, setEditMode,handleEmpty } = useContext(TeamContext);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    handleEmpty();
    setOpen(false);
  };


  return (
    <>
      <Card
        sx={{
          width: 235,
          height: 225,
          position: "relative",
          cursor: "pointer",
          border: 0,
          bgcolor: alpha(
            PRIMARY_COLOR_MediumRoyalBlue,
            theme.palette.action.selectedOpacity
          ),
        }}
        onMouseOver={() => setShow(item.teamId)}
        onMouseLeave={() => setShow(-1)}
      >
        <div className={classes.buttonContainer}>
          {!(show === item.teamId) ? null : (
            <>
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setClickedTeamId(item.teamId);
                    setOpenDel(true);
                  }}
                >
                  <DeleteRoundedIcon
                    sx={{ fontSize: 20, color: theme.palette.text.secondary }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    handleOpen();
                    handleAddData(item);
                    setEditMode(true);
                  }}
                >
                  <CreateRoundedIcon
                    sx={{ fontSize: 20, color: theme.palette.text.secondary }}
                  />
                </IconButton>
              </Tooltip>
            </>
          )}
        </div>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Avatar
              sx={{
                width: 120,
                height: 120,
                marginBottom: 2,
              }}
              src={getAPIEndpointUrl() + item.image}
            />
          </Box>
          <Box>
            <Typography
              onClick={() => {
                setOpenDetail(true);
                setDetailItem(item)
              }}
              color={PRIMARY_COLOR_MediumRoyalBlue}
              variant="h5"
              sx={{ textAlign: "center" }}
            >
              {item.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              {item.designation}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <TeamModal
        title="Edit Team"
        text="Update Team"
        open={open}
        id={item.teamId}
        previousTeam={item}
        handleClose={handleClose}
        handlerFunction={handleEditTeam}
      />
      <ConfirmationDialog
        loading={load}
        open={openDel}
        close={setOpenDel}
        confirm={handleDeleteTeam}
        title="Confirmation"
        message="Are you sure you want to delete this?"
        cancelBtnText="Cancel"
        confirmBtnText="Delete"
        pageName="team"
      />
    </>
  );
}
